import { render } from "./RateView.vue?vue&type=template&id=a34cb372&scoped=true"
import script from "./RateView.vue?vue&type=script&lang=js"
export * from "./RateView.vue?vue&type=script&lang=js"

import "./RateView.vue?vue&type=style&index=0&id=a34cb372&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a34cb372"]])

export default __exports__